import React, { memo } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Gallery from '../components/ui/Gallery';
const AnniversaryGallery = () => {
  const historicalImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c8nkRq8o8BbU7KKu56ZSnF/WhatsApp_Image_2025-08-14_at_15.45.37_%285%29.jpg',
    alt: 'Early school building',
    caption: 'Early days of the school campus'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg',
    alt: 'School assembly',
    caption: 'Students gathering for morning assembly'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg',
    alt: 'Students in uniform',
    caption: 'Proud IGS students in their uniforms'
  }];
  const anniversaryBanners = [{
    src: 'https://cdn.magicpatterns.com/uploads/fm5aeM6UoSmUd8iyr5whV6/IGS.jpg',
    alt: 'IGS @ 70 Anniversary Banner — All Alumni Sets',
    caption: 'IGS @ 70: Celebrating 70 Years of Impactful & Enduring Legacy in Education — Still Soaring at Seventy'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/uQsM27rbNPREQmqUu3VS3W/IGS_70.jpg',
    alt: 'IGS @ 70 — 23rd March 1956 to 23rd March 2026',
    caption: "70th Founder's Day Anniversary — Hosted by IGS National Alumni Association in collaboration with School Management & The Isonyin Community"
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/k2BvjZy7n4KdfdkpLXvwi5/WhatsApp_Image_2026-03-17_at_13.15.58.jpg',
    alt: 'IGS @ 70 Anniversary Flyer',
    caption: "IGS @ 70 — 23rd–29th March, 2026. Hosts: IGS National Alumni Association & 70th Founder's Day Anniversary Planning Committee"
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9SCpHLSdj2gFeMaWvjkG7d/Programme_of_events.jpg',
    alt: 'Programme of Events — 70th Anniversary',
    caption: 'Official Programme of Events: Monday 23rd – Sunday 29th March, 2026'
  }];
  const preparationImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/keQ1z5dAhNMgYe2HztvvFc/WhatsApp_Image_2026-02-19_at_14.06.18.jpg',
    alt: 'Staff planning meeting',
    caption: 'Staff and community members at an anniversary planning session'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4BLAurHpHDTJys8pMyfP5D/WhatsApp_Image_2026-02-19_at_14.10.23.jpg',
    alt: 'Students assembled on campus',
    caption: 'IGS students in their iconic blue uniforms gathered on campus'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/qNUMAPwjKxXJgQ7Cmi46du/WhatsApp_Image_2026-02-19_at_14.10.24_(1).jpg',
    alt: 'Happy students on campus grounds',
    caption: 'Smiling students with the school buildings in the background'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/sy2fp2k6vQ2gmvVmHC3E1e/WhatsApp_Image_2026-02-19_at_14.10.24.jpg',
    alt: 'Students during assembly',
    caption: 'Students during a special assembly ahead of the anniversary'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xpARZk6EqGjvu9VViCYM9y/WhatsApp_Image_2026-02-19_at_14.10.25_(1).jpg',
    alt: 'Students near classroom block',
    caption: 'Students near the classroom block during anniversary preparations'
  }];
  const recentEventsImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    alt: 'Cultural performance',
    caption: 'Cultural Day Celebration'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg',
    alt: 'Sports team',
    caption: 'Inter-House Sports Competition'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Science practical',
    caption: 'Science Exhibition'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'Alumni gathering',
    caption: 'Alumni Reunion Event'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-3903">
      <PageHeader title="Anniversary Gallery" description="A visual journey through 70 years of history, memories, and celebrations at Isonyin Grammar School." backgroundImage="https://cdn.magicpatterns.com/uploads/4BLAurHpHDTJys8pMyfP5D/WhatsApp_Image_2026-02-19_at_14.10.23.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: '70th Anniversary',
      path: '/anniversary'
    }, {
      label: 'Gallery',
      path: '/anniversary-gallery'
    }]} data-id="element-3904" />

      <div className="container mx-auto px-4 py-16" data-id="element-3905">
        {/* Hero Mosaic */}
        <div className="mb-16" data-id="element-3906">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[240px]" data-id="element-3907">
            <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-lg" data-id="element-3908">
              <img src="https://cdn.magicpatterns.com/uploads/qNUMAPwjKxXJgQ7Cmi46du/WhatsApp_Image_2026-02-19_at_14.10.24_(1).jpg" alt="Students smiling on campus" className="w-full h-full object-cover" data-id="element-3909" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-3910">
              <img src="https://cdn.magicpatterns.com/uploads/keQ1z5dAhNMgYe2HztvvFc/WhatsApp_Image_2026-02-19_at_14.06.18.jpg" alt="Staff planning meeting" className="w-full h-full object-cover" data-id="element-3911" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-3912">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c8nkRq8o8BbU7KKu56ZSnF/WhatsApp_Image_2025-08-14_at_15.45.37_%285%29.jpg" alt="School campus" className="w-full h-full object-cover" data-id="element-3913" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-3914">
              <img src="https://cdn.magicpatterns.com/uploads/xpARZk6EqGjvu9VViCYM9y/WhatsApp_Image_2026-02-19_at_14.10.25_(1).jpg" alt="Students near classroom" className="w-full h-full object-cover" data-id="element-3915" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md relative" data-id="element-3916">
              <img src="https://cdn.magicpatterns.com/uploads/sy2fp2k6vQ2gmvVmHC3E1e/WhatsApp_Image_2026-02-19_at_14.10.24.jpg" alt="Students assembled" className="w-full h-full object-cover" data-id="element-3917" />
              <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center" data-id="element-3918">
                <span className="text-white text-lg font-bold" data-id="element-3919">70 Years ✦</span>
              </div>
            </div>
          </div>
        </div>

        {/* Official Anniversary Banners & Programme */}
        <div className="mb-16" data-id="element-3920">
          <div className="text-center mb-10" data-id="element-3921">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-3922">
              Official Anniversary Banners & Programme
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6" data-id="element-3923"></div>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3924">
              Official banners and programme of events for the 70th Founder's
              Day Anniversary Celebration — 23rd to 29th March, 2026.
            </p>
          </div>
          <Gallery images={anniversaryBanners} columns={2} gap="medium" rounded={true} data-id="element-3925" />
        </div>

        {/* Down Memory Lane */}
        <div className="mb-16" data-id="element-3926">
          <div className="text-center mb-10" data-id="element-3927">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-3928">
              Down Memory Lane
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6" data-id="element-3929"></div>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3930">
              Historical photos capturing the early days and evolution of our
              great institution.
            </p>
          </div>
          <Gallery images={historicalImages} columns={3} gap="medium" rounded={true} data-id="element-3931" />
        </div>

        {/* Anniversary Preparations */}
        <div className="mb-16" data-id="element-3932">
          <div className="text-center mb-10" data-id="element-3933">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-3934">
              Anniversary Preparations
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6" data-id="element-3935"></div>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3936">
              Behind the scenes — our staff, students, and community coming
              together to prepare for the 70th Anniversary celebration.
            </p>
          </div>
          <Gallery images={preparationImages} columns={3} gap="medium" rounded={true} data-id="element-3937" />
        </div>

        {/* Recent Celebrations */}
        <div data-id="element-3938">
          <div className="text-center mb-10" data-id="element-3939">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-3940">
              Recent Celebrations & Events
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6" data-id="element-3941"></div>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3942">
              Glimpses of recent school activities, alumni gatherings, and
              preparations for the 70th Anniversary.
            </p>
          </div>
          <Gallery images={recentEventsImages} columns={4} gap="small" rounded={true} data-id="element-3943" />
        </div>
      </div>
    </div>;
};
export default AnniversaryGallery;